import React from 'react';

import { isUUIDV4 } from '@aline/common';
import { GenericPropertyIcon } from 'src/components/icons/GenericPropertyIcon';
import { QuestionModeIcon } from 'src/components/reports/report-detail/ReportCellPopover';
import { useGetExtractionQuestion } from 'src/hooks/extraction/extraction';

interface ColumnIconProps {
  columnId: string;
}

export function ColumnIcon({ columnId }: ColumnIconProps): JSX.Element {
  const isAIField = isUUIDV4(columnId);
  const { extractionQuestion } = useGetExtractionQuestion(columnId, { skip: !isAIField });

  if (isAIField) return <QuestionModeIcon mode={extractionQuestion?.mode} />;
  return <GenericPropertyIcon />;
}
